import { unitDefault, unitTypes } from "@/settings/unitTypes";
export const GeneTri = {
  id: "26",
  name: "Generador",
  mainClass: "Rotativos",
  subtype: "Trifásico",
  variables: [],
  operationalValues: [
    {
      value: 0,
      type: unitTypes.voltage,
      unit: unitDefault.voltage.metric,
      code: "generatorVoltage"
    },
    {
      value: 0,
      type: unitTypes.power,
      unit: unitDefault.power.metric,
      code: "generatorPower"
    },
    {
      value: 0,
      type: unitTypes.percentage,
      unit: unitDefault.percentage.metric,
      code: "generatorEfficiency"
    },
    {
      value: "Generator",
      type: "unique",
      unit: "",
      code: "generatorDriven"
    },
    {
      value: 0,
      type: unitTypes.frequency,
      unit: unitDefault.frequency.metric,
      code: "generatorFrequency"
    },
    {
      value: 0,
      type: unitTypes.angularSpeed,
      unit: unitDefault.angularSpeed.metric,
      code: "generatorSpeed"
    },
    {
      value: 0.7,
      type: "unique",
      unit: "",
      code: "generatorPowerFactor"
    }
  ]
};
